module.exports = __webpack_public_path__ + "img/智能监护bj.02f11027.png";